<template>
  <div
    :class="[
      'relative flex items-center justify-center w-full outline-none group sm:rounded-xl bg-slate-100 dark:bg-zinc-800',
      type !== ItemType.PDF && 'content-wrapper',
      type === ItemType.PDF ? 'overflow-hidden sm:overflow-visible' : 'overflow-hidden',
    ]"
  >
    <div class="w-full h-full text-center flex justify-center items-center" @mouseenter="handleHover(true)" @mouseleave="handleHover(false)">
      <template v-if="canViewItem && contentUrl && !limitReached">
        <Image v-if="type === ItemType.IMAGE" :src="annotate.image || contentUrl" :alt="displayName" />
        <Pdf v-else-if="type === ItemType.PDF" :src="contentUrl" />
        <Audio v-else-if="type === ItemType.AUDIO" :src="contentUrl" />
        <template v-else-if="type === ItemType.VIDEO">
          <FloatingBarAI />
          <Video :src="contentUrl" />
        </template>
        <Unsupported v-else :src="contentUrl" />
        <ContentCollectionNav />

        <div id="cta-wrapper" v-show="!!hoverableButtonVisible || showHoverableButton">
          <CallToAction :hoverOnly="true" />
        </div>
      </template>
      <ViewsLimit v-else-if="limitReached" />
      <Skeleton v-else />
      <div id="cta-wrapper" v-show="!!hoverableButtonVisible">
        <CallToAction :hoverOnly="true" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Skeleton from './ContentSkeleton.vue';
import { useViewerItemStore, ItemType } from './../store/useViewerItemStore';
import Image from './content_types/Image.vue';
import Pdf from './content_types/Pdf.vue';
import Video from './content_types/Video.vue';
import Audio from './content_types/Audio.vue';
import Unsupported from './content_types/Unsupported.vue';
import CallToAction from './CallToAction.vue';
import ViewsLimit from './limitations/ViewsLimit.vue';
import FloatingBarAI from './FloatingBarAI.vue';

import { useCallToActionStore } from './../store/useCallToActionStore';
import { storeToRefs } from 'pinia';
import ContentCollectionNav from './ContentCollectionNav.vue';

const viewerItemStore = useViewerItemStore();
const ctaStore = useCallToActionStore();
const { hoverableButtonVisible, showHoverableButton } = storeToRefs(ctaStore);
const { type, contentUrl, displayName, limitReached, annotate, canViewItem } = storeToRefs(viewerItemStore);
const handleHover = (value: boolean) => {
  if (viewerItemStore.type !== ItemType.VIDEO) {
    ctaStore.ctaHoverableButtonVisible(value);
  }
};
</script>
